<template>
    <div class="switcher">
        <button :class="{ active: isLeftActive }" @click="onLeftClick" class="switcher__btn left">
            <slot name="leftValue" />
        </button>
        <button :class="{ active: !isLeftActive, disabled: disabled || !auth }" @click="onRightClick" class="switcher__btn right">
            <slot name="rightValue" />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        leftClickHandler: {
            type: Function,
            default: () => {}
        },
        rightClickHandler: {
            type: Function,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        isLeftActive: true
    }),
    methods: {
        onLeftClick() {
            if(!this.$props.disabled && !this.isLeftActive) {
                this.isLeftActive = true
                this.$props.leftClickHandler()
                $('#tiles').trigger('resize')
            }
            return
        },
        onRightClick() {
            if(!this.$props.disabled && this.isLeftActive) {
                this.isLeftActive = false
                this.$props.rightClickHandler()
                $('#tiles').trigger('resize')
            }
        }
    },
    computed: {
        auth() { return this.$store.state?.user?.auth }
    }
}
</script>

<style lang="sass" scoped>
    @import '../../../../styles/global-variables'

    .switcher
        display: flex;
        &__btn
            @include tile-button()
        .left
            border-top-right-radius: 0
            border-bottom-right-radius: 0
        .right
            border-top-left-radius: 0
            border-bottom-left-radius: 0
            margin-left: -1px
        .active
            color: #cbc7cd
            background-color: #f5f5f5
            border-color: rgba(0,0,0,.2)
            border-top-color: rgba(0,0,0,.3)
            background-image: none
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, .1)
            cursor: default
        .disabled
            background-color: #fafafa
            color: #999
            border-color: rgba(0,0,0,.2)
            background-image: none
            box-shadow: none
            text-shadow: 0 1px 0 #fff
            cursor: default
            
</style>